import type { CSSProperties } from "react";
import { resolveThemeColor } from "@/lib/visual-cms/theme-palette";
import type { VisualCmsSection } from "@/types/visual-cms";

/**
 * Compute the wrapper style + class for any section renderer based on the
 * shell fields (background_color, text_color). Keeps a single source of truth
 * for how Visual CMS sections apply their theme.
 */
export function sectionShellStyle(section: VisualCmsSection): {
  style: CSSProperties;
  className: string;
} {
  const style: CSSProperties = {};
  const bg = resolveThemeColor(section.background_color);
  const fg = resolveThemeColor(section.text_color);
  if (bg) style.backgroundColor = bg;
  if (fg) style.color = fg;
  return {
    style,
    className: "py-12 sm:py-16 lg:py-20",
  };
}

/**
 * Container helper used by every renderer to keep horizontal padding +
 * max-width consistent across section types.
 */
export const SECTION_CONTAINER = "max-w-6xl mx-auto px-4 sm:px-6";
